<template>
  <div id="mobileCxMgmt">

    <!-- ══ 搜尋列（可收合）══ -->
    <div class="m-search-block">
      <div class="m-search-header" @click="searchExpanded = !searchExpanded">
        <span><i class="el-icon-search"></i>搜尋條件</span>
        <i :class="searchExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
      <transition name="slide">
        <div v-show="searchExpanded" class="m-search-body">
          <div class="m-field-row m-field-row--two">
            <div class="m-inline-item">
              <label>資料來源</label>
              <el-select v-model="listQuery.source" placeholder="請選擇資料來源" clearable class="m-inline-ctrl">
                <el-option label="自行開發" value="自行開發"></el-option>
              </el-select>
            </div>
            <div class="m-inline-item">
              <label>專案名稱</label>
              <el-select v-model="listQuery.ProjectName" placeholder="請選擇專案名稱" clearable class="m-inline-ctrl">
                <el-option v-for="item in ProjectNameList" :key="item.ID" :label="item.ProjectName" :value="item.ProjectName"></el-option>
              </el-select>
            </div>
          </div>
          <div class="m-field-row m-field-row--three">
            <div class="m-inline-item m-inline-item--date">
              <label>建立時間</label>
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
                class="m-inline-ctrl"
                :picker-options="pickerOptions">
              </el-date-picker>
            </div>
            <div class="m-inline-item">
              <label>關鍵字</label>
              <el-input v-model="keyword" placeholder="公司名稱 / 統一編號" clearable class="m-inline-ctrl"></el-input>
            </div>
            <div class="m-inline-action">
              <el-button type="primary" icon="el-icon-search" @click="doSearch">搜尋</el-button>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- ══ 工具列（選取操作）══ -->
    <div class="m-toolbar" v-if="selectedIds.length > 0">
      <span class="m-sel-count">已選 {{ selectedIds.length }} 筆</span>
      <el-button size="mini" type="success" @click="openAddTagDialog">
        <i class="el-icon-price-tag"></i> 新增標籤
      </el-button>
      <el-button v-if="btnStartCaseVisible" size="mini" type="primary" @click="startupBatchCase">
        <i class="el-icon-edit"></i> 整批起案
      </el-button>
      <el-button size="mini" type="warning" @click="exportCase">
        <i class="el-icon-download"></i> 匯出
      </el-button>
      <el-button size="mini" @click="clearSelection">清除</el-button>
    </div>

    <!-- ══ 卡片列表 ══ -->
    <div class="m-card-list" v-loading="loading">
      <div v-if="tableData.length === 0 && !loading" class="m-empty">暫無資料</div>

      <div v-for="row in tableData" :key="row.ID"
           class="m-cx-card"
           :class="{ 'is-selected': selectedIds.includes(row.ID) }">

        <!-- 卡片頂列：checkbox + 公司名稱 + 操作按鈕 -->
        <div class="m-card-top">
          <el-checkbox
            :value="selectedIds.includes(row.ID)"
            @change="toggleSelect(row)"
            @click.native.stop>
          </el-checkbox>
          <div class="m-com-info" >
            <span class="m-uni" @click="doShowCompanyDetail(row)">{{ row.UniComNm }}</span>
            <span class="m-com-name" @click="doshowDetail(row)">{{ row.ComName }}</span>            
          </div>
          <div class="m-card-actions">
            <el-button size="mini" type="primary" plain @click="btnOpDetail(row)">明細</el-button>
            <el-button size="mini" type="danger"  plain @click="btnOpDelete(row)">刪除</el-button>
            <el-button v-if="btnStartCaseVisible" size="mini" type="success" plain @click="btnOpStartCase(row)">起案</el-button>
          </div>
        </div>

        <!-- 卡片內容 -->
        <div class="m-card-meta">
          <span class="m-meta-item"><i class="el-icon-folder"></i> {{ row.ProjectName || '—' }}</span>
          <span class="m-meta-item"><i class="el-icon-time"></i> {{ row.CreateDt || '—' }}</span>
        </div>
      </div>
    </div>

    <!-- ══ 分頁 ══ -->
    <div class="m-page-bar">
      <Pagination
        @currentChange="pageChange"
        :pageSize="listQuery.Page_Size"
        :propsCurrentPage="listQuery.Page_Num"
        :totalLists="totalLists">
      </Pagination>
    </div>

    <!-- ══ FAB：新增潛在客戶 ══ -->
    <el-button class="m-fab" type="primary" circle icon="el-icon-plus" @click="addNewCx"></el-button>

    <!-- ══ 對話框：新增 / 編輯客戶 ══ -->
    <el-dialog :title="popTitle" :visible.sync="dialogVisible" width="95%" center :close-on-click-modal="false">
      <div class="m-dialog-form">
        <div class="m-form-item">
          <label>統一編號</label>
          <el-input v-model="selectedCase.UniComNm" ></el-input>
        </div>
        <div class="m-form-item">
          <label>公司名稱</label>
          <el-input v-model="selectedCase.ComName"></el-input>
        </div>
        <div class="m-form-item">
          <label>資料來源</label>
          <el-input v-model="selectedCase.Source" disabled></el-input>
        </div>
        <div class="m-form-item">
          <label>專案名稱</label>
          <div style="display:flex;gap:8px;align-items:center;flex:1;">
            <el-select v-model="changeProjectID" placeholder="請選擇專案名稱" style="flex:1;">
              <el-option v-for="item in ProjectNameList" :key="item.ID" :label="item.ProjectName" :value="item.ID"></el-option>
            </el-select>
            <el-dropdown trigger="click" @command="handleProjectName">
              <el-button size="mini" type="primary" icon="el-icon-setting"></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="add"><i class="el-icon-plus"></i> 新增專案名稱</el-dropdown-item>
                <el-dropdown-item command="edit"><i class="el-icon-edit"></i> 修改專案名稱</el-dropdown-item>
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i> 刪除專案名稱</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="m-form-item">
          <label>區處</label>
          <el-input v-model="selectedCase.DivisionName" disabled></el-input>
        </div>
        <div class="m-form-item">
          <label>分行名稱</label>
          <el-input v-model="selectedCase.DeptName" disabled></el-input>
        </div>
        <div class="m-form-item">
          <label>承辦人</label>
          <el-input v-model="selectedCase.UserName" disabled></el-input>
        </div>
        <div class="m-form-item">
          <label>建立時間</label>
          <el-input v-model="selectedCase.CreateDt" disabled></el-input>
        </div>
        <div class="m-form-item">
          <label>備註</label>
          <el-input v-model="selectedCase.Memo" type="textarea" :rows="2"></el-input>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="saveDetail"><i class="el-icon-check"></i> 儲存</el-button>
        <el-button type="danger"  @click="dialogVisible = false"><i class="el-icon-close"></i> 關閉</el-button>
      </span>
    </el-dialog>

    <!-- ══ 對話框：起案 ══ -->
    <el-dialog title="案件起案" :visible.sync="startCaseDialogVisible" width="95%" center :close-on-click-modal="false">
      <div class="m-dialog-form">
        <div class="m-form-item"><label>統一編號</label><span>{{ selectedCase.UniComNm }}</span></div>
        <div class="m-form-item"><label>公司名稱</label><span>{{ selectedCase.ComName }}</span></div>
        <div class="m-form-item"><label>專案名稱</label><span>{{ selectedCase.ProjectName }}</span></div>
        <div class="m-form-item"><label>區處</label><span>{{ selectedCase.DivisionName }}</span></div>
        <div class="m-form-item"><label>分行名稱</label><span>{{ selectedCase.DeptName }}</span></div>
        <div class="m-form-item"><label>承辦人</label><span>{{ selectedCase.UserName }}</span></div>
        <div class="m-form-item">
          <label>預計訪問時間</label>
          <el-date-picker v-model="expectedVisitDate" type="date" value-format="yyyy-MM-dd" placeholder="選擇日期" style="flex:1;"></el-date-picker>
        </div>
        <div class="m-form-item">
          <label>限辦期限</label>
          <el-date-picker v-model="dueDate" type="date" value-format="yyyy-MM-dd" placeholder="選擇日期" style="flex:1;"></el-date-picker>
        </div>
        <div class="m-form-item">
          <label>備註</label>
          <el-input v-model="selectedCase.Memo" type="textarea" :rows="2" style="flex:1;"></el-input>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="startCase"><i class="el-icon-edit"></i> 起案</el-button>
        <el-button type="danger"  @click="startCaseDialogVisible = false"><i class="el-icon-close"></i> 關閉</el-button>
      </span>
    </el-dialog>

    <!-- ══ 對話框：新增企業標籤 ══ -->
    <el-dialog title="新增企業標籤" :visible.sync="showAddTagDialog" width="95%" center>
      <div class="m-dialog-form">
        <div class="m-form-item">
          <label>公司名稱</label>
          <div style="flex:1;padding:8px;background:#f5f7fa;border-radius:4px;border:1px solid #dcdfe6;font-size:13px;">
            <span v-if="selectedComUniComNmList.length === 0" style="color:#909399;">尚未選擇公司</span>
            <span v-else-if="selectedComUniComNmList.length === 1">{{ getCompanyName(selectedComUniComNmList[0]) }}</span>
            <span v-else>{{ getCompanyName(selectedComUniComNmList[0]) }} 等 {{ selectedComUniComNmList.length }} 家公司</span>
          </div>
        </div>
        <div class="m-form-item">
          <label>標籤內容</label>
          <el-input v-model="newTagForm.content" placeholder="多個標籤以逗號, 隔開" style="flex:1;"></el-input>
        </div>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="saveNewTagFromDrawer" :disabled="selectedComUniComNmList.length === 0">儲存</el-button>
        <el-button @click="showAddTagDialog = false">取消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Pagination from '../../../components/Pagination.vue';
import { notify, handleError } from '../../../utils/notify';
import ExcelJS from 'exceljs';

export default {
  name: 'MobileCxMgmt',
  components: { Pagination },
  data() {
    return {
      searchExpanded: true,
      loading: false,

      btnUploadNameVisible: false,
      btnStartCaseVisible: false,

      // 標籤相關
      showAddTagDialog: false,
      selectedComUniComNm: '',
      selectedComUniComNmList: [],
      newTagForm: { content: '' },

      popTitle: '新增潛在客戶名單',
      dialogVisible: false,
      startCaseDialogVisible: false,

      tableData: [],
      totalLists: 0,

      // 卡片選取（用 ID array 管理跨頁選取）
      selectedIds: [],
      selectedMap: {},   // ID -> row 物件，方便匯出

      keyword: '',
      dateRange: [],
      listQuery: {
        Page_Size: 10,
        Page_Num: 1,
        source: '',
        ProjectName: '',
      },

      ProjectNameList: [],
      changeProjectID: '',

      selectedCase: {},
      addOrEdit: 'add',
      expectedVisitDate: '',
      dueDate: '',

      pickerOptions: {
        shortcuts: [
          {
            text: '最近一週',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一個月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三個月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },

  methods: {
    // ── 卡片選取 ──────────────────────────────────────────────
    toggleSelect(row) {
      const idx = this.selectedIds.indexOf(row.ID);
      if (idx === -1) {
        this.selectedIds.push(row.ID);
        this.selectedMap[row.ID] = row;
      } else {
        this.selectedIds.splice(idx, 1);
        delete this.selectedMap[row.ID];
      }
    },
    clearSelection() {
      this.selectedIds = [];
      this.selectedMap = {};
    },
    getSelectedRows() {
      return Object.values(this.selectedMap);
    },



    // ── 導覽 ──────────────────────────────────────────────────
    // ── 導航：行動版改為開新視窗─────────
    doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名

            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		      
    },

    doshowDetail(row) {
      this.$queryRecord && this.$queryRecord(this, row.ComName, 'company');
            const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
            window.open(url, '_blank');      
      // const routeData = this.$router.resolve({
      //   name: 'm-ctm-map-com',
      //   query: { unicomnm: row.UniComNm },
      // });
      // window.open(routeData.href, '_blank');
    },


    // ── 工具列按鈕 ───────────────────────────────────────────
    openAddTagDialog() {
      this.newTagForm.content = '';
      const rows = this.getSelectedRows();
      if (!rows || rows.length === 0) {
        notify({ title: '請注意', type: 'warning', message: '請先勾選要新增標籤的公司' });
        return;
      }
      this.selectedComUniComNmList = rows.map(r => r.UniComNm);
      this.showAddTagDialog = true;
    },

    getCompanyName(uniComNm) {
      const company = this.tableData.find(item => item.UniComNm === uniComNm)
        || Object.values(this.selectedMap).find(item => item.UniComNm === uniComNm);
      return company ? company.ComName : uniComNm;
    },

    async saveNewTagFromDrawer() {
      if (!this.newTagForm.content.trim()) {
        notify({ title: '請注意', type: 'warning', message: '請輸入標籤內容' });
        return;
      }
      if (!this.selectedComUniComNmList || this.selectedComUniComNmList.length === 0) {
        notify({ title: '請注意', type: 'warning', message: '未選擇公司' });
        return;
      }
      const tagArray = this.newTagForm.content.split(',').map(t => t.trim()).filter(t => t !== '');
      const successList = [];
      const failList = [];
      try {
        for (const uniComNm of this.selectedComUniComNmList) {
          try {
            await this.$api.apitags.add_category_tag({ UniComNm: uniComNm, TagValues: tagArray });
            successList.push(uniComNm);
          } catch (e) {
            failList.push(uniComNm);
          }
        }
        if (failList.length === 0) {
          notify({ type: 'success', title: '成功', message: `已為 ${successList.length} 家公司新增標籤` });
        } else if (successList.length === 0) {
          notify({ type: 'error', title: '失敗', message: `所有公司新增標籤失敗` });
        } else {
          notify({ type: 'warning', title: '部分成功', message: `成功 ${successList.length} 家，失敗 ${failList.length} 家` });
        }
        this.showAddTagDialog = false;
        this.newTagForm.content = '';
        this.selectedComUniComNmList = [];
        setTimeout(() => { this.getList(); }, 500);
      } catch (err) {
        handleError(err, '新增標籤失敗');
      }
    },

    // ── 專案名稱操作 ─────────────────────────────────────────
    handleProjectName(command) {
      if (command === 'add') this.addProjectName();
      else if (command === 'edit') this.editProjectName();
      else if (command === 'delete') this.deleteProjectName();
    },

    async addProjectName() {
      this.$prompt('請輸入新的專案名稱', '新增專案名稱', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '專案名稱不可為空',
      }).then(async ({ value }) => {
        const trimmedName = value.trim();
        if (!trimmedName) {
          notify({ title: '警告', message: '專案名稱不可為空', type: 'warning' });
          return;
        }
        if (this.ProjectNameList.some(item => item.ProjectName === trimmedName)) {
          notify({ title: '警告', message: `專案名稱 "${trimmedName}" 已存在`, type: 'warning' });
          return;
        }
        try {
          await this.$api.apipocxpj.pocxpj_create({ ProjectName: trimmedName });
          await this.loadProjectNameList();
          notify({ title: '成功', message: `成功新增專案名稱 "${trimmedName}"`, type: 'success' });
        } catch (err) {
          handleError(err, '新增專案名稱失敗');
        }
      }).catch(() => {});
    },

    editProjectName() {
      if (!this.changeProjectID) {
        notify({ title: '警告', message: '請先選擇要修改的專案名稱', type: 'warning' });
        return;
      }
      this.$prompt('請輸入新的專案名稱', '修改專案名稱', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        inputPattern: /.+/,
        inputErrorMessage: '專案名稱不可為空',
      }).then(async ({ value }) => {
        try {
          const res = await this.$api.apipocxpj.pocxpj_update({
            ID: this.changeProjectID,
            ProjectName: value.trim(),
          });
          if (res.statuscode === 200) {
            await this.loadProjectNameList();
            notify({ title: '成功', message: `成功修改專案名稱為 "${value.trim()}"`, type: 'success' });
          } else {
            notify({ title: '錯誤', message: `修改失敗: ${res.message || '未知錯誤'}`, type: 'error' });
          }
        } catch (err) {
          handleError(err, '修改專案名稱失敗');
        }
      }).catch(() => {});
    },

    deleteProjectName() {
      if (!this.changeProjectID) {
        notify({ title: '警告', message: '請先選擇要刪除的專案名稱', type: 'warning' });
        return;
      }
      const proj = this.ProjectNameList.find(item => item.ID === parseInt(this.changeProjectID));
      if (!proj) return;
      this.$confirm(`確定要刪除專案名稱 "${proj.ProjectName}" 及其所有潛在客戶 嗎?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          const respPocx = await this.$api.apipocx.pocx_search({
            ProjectName: proj.ProjectName,
            Page_Num: 1,
            Page_Size: 100,
          });
          if (respPocx.data.length > 0) {
            await this.$api.apipocx.pocx_delete({ IDs: respPocx.data.map(item => item.ID) });
          }
          await this.$api.apipocxpj.pocxpj_delete({ ID: this.changeProjectID });
          const index = this.ProjectNameList.findIndex(item => item.ID === parseInt(this.changeProjectID));
          if (index !== -1) this.ProjectNameList.splice(index, 1);
          this.changeProjectID = '';
          notify({ type: 'success', message: '專案名稱已成功刪除' });
        } catch (err) {
          handleError(err, '刪除專案名稱失敗');
        }
      }).catch(() => {
        notify({ type: 'info', message: '已取消刪除操作' });
      });
    },

    // ── 新增 / 編輯客戶 ─────────────────────────────────────
    async addNewCx() {
      this.selectedCase = {
        UniComNm: '',
        ComName: '',
        Source: '自行開發',
        ProjectName: '',
        DivisionName: '',
        DeptName: '',
        UserName: '',
        CreateDt: '',
        Memo: '',
      };
      this.popTitle = '新增潛在客戶名單';
      const deptID = window.localStorage.getItem('deptID');
      const divisionInfo = await this.getDivisionInfo(deptID);
      if (divisionInfo) {
        this.selectedCase.DivisionName = divisionInfo.DivisionName;
        this.selectedCase.DeptName = divisionInfo.DeptName;
      }
      this.selectedCase.UserName = this.$store.state.userInfo?.UserName || '';
      this.selectedCase.CreateDt = new Date().toISOString().split('T')[0];
      this.addOrEdit = 'add';
      this.changeProjectID = '';
      this.dialogVisible = true;
    },

    btnOpDetail(row) {
      this.popTitle = '編輯客戶名單資訊';
      this.selectedCase = { ...row, Source: '自行開發' };
      this.changeProjectID = row.ProjectID;
      this.addOrEdit = 'edit';
      this.dialogVisible = true;
    },

    btnOpDelete(row) {
      this.$confirm(`確定要刪除 ${row.ComName} 嗎?`, '提示', {
        confirmButtonText: '刪除',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$api.apipocx.pocx_delete({ IDs: [row.ID] });
          notify({ title: '成功', message: '刪除客戶成功', type: 'success' });
          // 同步清除選取狀態
          const idx = this.selectedIds.indexOf(row.ID);
          if (idx !== -1) {
            this.selectedIds.splice(idx, 1);
            delete this.selectedMap[row.ID];
          }
          this.getList();
        } catch (err) {
          handleError(err, '刪除客戶失敗');
        }
      }).catch(() => {
        notify({ title: '信息', message: '已取消刪除', type: 'info' });
      });
    },

    btnOpStartCase(row) {
      this.selectedCase = { ...row };
      this.expectedVisitDate = '';
      this.dueDate = '';
      this.startCaseDialogVisible = true;
    },

    async startCase() {
      const qry = {
        Project_Name: this.selectedCase.ProjectName,
        UniComNm: this.selectedCase.UniComNm,
        ComName: this.selectedCase.ComName,
      };
      if (this.selectedCase.Memo?.trim()) qry.Memo = this.selectedCase.Memo;
      if (this.expectedVisitDate) qry.Expect_Visit_Dt = this.expectedVisitDate;
      if (this.dueDate) qry.Due_Dt = this.dueDate;
      try {
        await this.$api.apicase.case_create(qry);
        await this.$api.apipocx.pocx_delete({ IDs: [this.selectedCase.ID] });
        notify({ title: '成功', message: '起案成功', type: 'success' });
        this.expectedVisitDate = '';
        this.dueDate = '';
        this.selectedCase = {};
        this.startCaseDialogVisible = false;
        setTimeout(() => { this.getList(); }, 1000);
      } catch (err) {
        handleError(err, '起案失敗');
      }
    },

    async startupBatchCase() {
      const rows = this.getSelectedRows();
      if (!rows || rows.length === 0) {
        notify({ title: '警告', message: '請先勾選要起案的客戶', type: 'warning' });
        return;
      }
      const successList = [];
      const failList = [];
      for (const row of rows) {
        try {
          await this.$api.apicase.case_create({
            Project_Name: row.ProjectName,
            UniComNm: row.UniComNm,
            ComName: row.ComName,
            memo: row.Memo,
          });
          await this.$api.apipocx.pocx_delete({ IDs: [row.ID] });
          successList.push(`${row.ComName}(${row.UniComNm})`);
        } catch (err) {
          failList.push(`${row.ComName}(${row.UniComNm})`);
        }
      }
      if (failList.length === 0) {
        this.$notify({ title: '起案完成', message: `成功起案 ${successList.length} 件`, type: 'success', duration: 3000 });
      } else if (successList.length === 0) {
        this.$notify({ title: '起案失敗', message: `${failList.length} 件全部失敗`, type: 'error', duration: 5000 });
      } else {
        this.$notify({ title: '起案完成（部分）', message: `成功 ${successList.length} 件，失敗 ${failList.length} 件`, type: 'warning', duration: 8000 });
      }
      this.clearSelection();
      setTimeout(() => { this.getList(); }, 1000);
    },

    // ── 儲存客戶 ─────────────────────────────────────────────
    saveDetail() {
      if (this.addOrEdit === 'add') {
        this.saveNewDetail();
      } else {
        this.saveEditDetail();
      }
    },

    saveNewDetail() {
      if (!this.selectedCase.UniComNm || !/^\d{8}$/.test(this.selectedCase.UniComNm)) {
        notify({ type: 'warning', title: '警告', message: '統一編號不可為空且必須數字8碼' });
        return;
      }
      if (!this.selectedCase.ComName?.trim()) {
        notify({ type: 'warning', title: '警告', message: '公司名稱不可為空' });
        return;
      }
      if (!this.changeProjectID) {
        notify({ type: 'warning', title: '警告', message: '請選擇專案名稱' });
        return;
      }
      this.$api.apipocx.pocx_create({
        UniComNm: this.selectedCase.UniComNm,
        ComName: this.selectedCase.ComName,
        ProjectID: this.changeProjectID,
        Memo: this.selectedCase.Memo,
      }).then(response => {
        if (response.statuscode === 200) {
          notify({ type: 'success', title: '成功', message: `已成功新增：${this.selectedCase.ComName}` });
        } else {
          notify({ type: 'error', title: '失敗', message: `新增失敗：${response.message}` });
        }
        this.dialogVisible = false;
        setTimeout(() => { this.getList(); }, 500);
      }).catch(err => {
        handleError(err, '新增潛在客戶失敗');
      });
    },

    saveEditDetail() {
      if (!this.changeProjectID) {
        notify({ type: 'warning', title: '警告', message: '請選擇專案名稱' });
        return;
      }
      this.$api.apipocx.pocx_update({
        ID: this.selectedCase.ID,
        ProjectID: this.changeProjectID,
        UniComNm: this.selectedCase.UniComNm,
        ComName: this.selectedCase.ComName,
        Memo: this.selectedCase.Memo,
      }).then(() => {
        notify({ title: '成功', message: '客戶資料更新成功', type: 'success' });
        this.dialogVisible = false;
        this.getList();
      }).catch(err => {
        handleError(err, '更新客戶資料失敗');
      });
    },

    // ── 查詢 / 載入資料 ──────────────────────────────────────
    dashFormat(value) {
      if (!value || value.length !== 8) return '';
      return `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6)}`;
    },

    async doSearch() {
      this.listQuery.Page_Num = 1;
      if (this.keyword?.trim()) {
        this.$queryRecord(this, this.keyword, 'keyword');
      }
      await this.getList();
    },

    async getList() {
      this.loading = true;
      const qry = {
        Page_Size: this.listQuery.Page_Size,
        Page_Num: this.listQuery.Page_Num,
      };
      if (this.listQuery.source) qry.source = this.listQuery.source;
      if (this.listQuery.ProjectName) qry.ProjectName = this.listQuery.ProjectName;
      if (this.keyword?.trim()) qry.SearchText = this.keyword.trim();
      if (this.dateRange && this.dateRange.length === 2) {
        const endDate = new Date(this.dateRange[1]);
        endDate.setDate(endDate.getDate() + 1);
        qry.CreateDateStart = this.dashFormat(this.dateRange[0].toISOString().split('T')[0].replace(/-/g, ''));
        qry.CreateDateEnd = this.dashFormat(endDate.toISOString().split('T')[0].replace(/-/g, ''));
      }
      const deptID = window.localStorage.getItem('deptID');
      if (deptID) qry.DeptID = deptID;

      try {
        const response = await this.$api.apipocx.pocx_search(qry);
        this.tableData = response.data;
        this.totalLists = response.total;
      } catch (err) {
        notify({ title: '錯誤', message: '獲取潛在客戶列表失敗，請稍後再試', type: 'error' });
      } finally {
        this.loading = false;
      }
    },

    async pageChange(val) {
      this.listQuery.Page_Num = val;
      await this.getList();
    },

    // ── 匯出 ─────────────────────────────────────────────────
    async exportCase() {
      const rows = this.getSelectedRows();
      if (!rows || rows.length === 0) {
        notify({ title: '警告', message: '請先勾選要匯出的潛在客戶', type: 'warning' });
        return;
      }
      try {
        const fieldMapping = [
          { key: 'UniComNm',    label: '統一編號' },
          { key: 'ComName',     label: '公司名稱' },
          { key: 'ProjectName', label: '專案名稱' },
          { key: 'DivisionName',label: '區處' },
          { key: 'DeptName',    label: '分行名稱' },
          { key: 'UserName',    label: '承辦人' },
          { key: 'CreateDt',    label: '建立時間' },
          { key: 'Memo',        label: '備註' },
        ];
        const exportData = rows.map(item => {
          const newItem = {};
          fieldMapping.forEach(f => { newItem[f.label] = item[f.key] || ''; });
          return newItem;
        });
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('潛在客戶列表');
        worksheet.columns = fieldMapping.map(field => ({
          header: field.label,
          key: field.label,
          width: 18,
        }));
        worksheet.addRows(exportData);
        const now = new Date();
        const ts = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}`;
        const fileName = `潛在客戶列表_${ts}.xlsx`;

        const excelBuffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        notify({ title: '成功', message: `已下載 ${rows.length} 筆資料`, type: 'success' });
      } catch (err) {
        handleError(err, '匯出失敗');
      }
    },

    // ── 輔助 ─────────────────────────────────────────────────
    async getDivisionInfo(DeptID) {
      try {
        const response = await this.$api.apidivison.division_info_list({ DeptID, Page_Num: 1, Page_Size: 1 });
        return response.data[0];
      } catch (err) {
        console.error('獲取區處分行資訊失敗', err);
        return null;
      }
    },

    loadProjectNameList() {
      const qry = {
        Page_Num: 1,
        Page_Size: 20,
        DeptID: window.localStorage.getItem('deptID'),
      };
      this.$api.apipocxpj.pocxpj_search(qry).then(response => {
        this.ProjectNameList = response.data;
      }).catch(() => {
        notify({ title: '錯誤', message: '獲取專案名稱失敗，請稍後再試', type: 'error' });
      });
    },

    getFunctions() {
      const roleName = window.localStorage.getItem('userRole');
      const DeptID = window.localStorage.getItem('deptID');
      this.btnStartCaseVisible = roleName === 'UAO' || roleName === 'UC';
      if (['HD', 'HC', 'HE', 'HC1'].includes(roleName) && DeptID !== '041') {
        this.btnUploadNameVisible = true;
      } else {
        this.btnUploadNameVisible = false;
      }
    },
  },

  async mounted() {
    this.$store.dispatch('loadingHandler', true);
    await this.loadProjectNameList();
    const today = new Date();
    const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
    this.dateRange = [threeMonthsAgo, today];
    this.getFunctions();
    await this.getList();
    this.$store.dispatch('loadingHandler', false);
  },
};
</script>

<style lang="scss" scoped>
$primary: #1c2d5e;
$active:  #2a5caa;

#mobileCxMgmt {
  min-height: 100vh;
  background: #f5f6fa;
  padding-bottom: 80px; // FAB 空間

  // ── 搜尋列 ──────────────────────────────────────
  .m-search-block {
    background: #fff;
    border-radius: 8px;
    margin: 12px;
    box-shadow: 0 1px 4px rgba(0,0,0,.08);

    .m-search-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 16px;
      font-weight: 600;
      color: $primary;
      cursor: pointer;
      user-select: none;
    }

    .m-search-body {
      padding: 0 16px 16px;
    }

    .m-field-row {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 10px;

      label {
        width: 64px;
        flex-shrink: 0;
        font-size: 13px;
        color: #606266;
        white-space: nowrap;
      }
    }

    .m-field-row--two,
    .m-field-row--three {
      align-items: center;
    }

    .m-inline-item {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .m-inline-item--date {
      flex: 1.2;
    }

    .m-inline-ctrl {
      flex: 1;
      min-width: 0;
    }

    .m-inline-action {
      flex-shrink: 0;

      .el-button {
        min-width: 88px;
      }
    }
  }

  // ── 工具列 ───────────────────────────────────────
  .m-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    background: #fff3e0;
    border-radius: 8px;
    margin: 0 12px 8px;
    padding: 10px 12px;
    border-left: 4px solid #ff9800;

    .m-sel-count {
      font-size: 13px;
      font-weight: 600;
      color: #e65100;
      margin-right: 4px;
    }
  }

  // ── 卡片列表 ────────────────────────────────────
  .m-card-list {
    padding: 0 12px;
  }

  .m-empty {
    text-align: center;
    color: #909399;
    padding: 40px 0;
    font-size: 14px;
  }

  .m-cx-card {
    background: #fff;
    border-radius: 10px;
    margin-bottom: 12px;
    padding: 14px 14px 10px;
    box-shadow: 0 1px 4px rgba(0,0,0,.07);
    border-left: 4px solid #c8d8f8;
    transition: border-color .2s;

    &.is-selected {
      border-left-color: $active;
      background: #f0f5ff;
    }

    .m-card-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      .m-com-info {
        flex: 1;
        cursor: pointer;
        display: flex;
        gap: 8px;
        align-items: center;
        flex-wrap: wrap;

        .m-com-name {
          display: block;
          font-size: 1rem;
          font-weight: 700;
          color: $active;
          margin-left: 0.5rem;
        }

        .m-uni {
          display: block;
          font-size: 1rem;
          color: #909399;
        }
      }
    }

    .m-card-meta {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin: 10px 0 8px 28px;

      .m-meta-item {
        font-size: 12px;
        color: #606266;

        i {
          margin-right: 3px;
          color: $primary;
        }
      }
    }

    .m-card-top .m-card-actions {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
    }
  }

  // ── 分頁 ────────────────────────────────────────
  .m-page-bar {
    padding: 8px 12px 0;
    display: flex;
    justify-content: center;
  }

  // ── FAB ─────────────────────────────────────────
  .m-fab {
    position: fixed;
    right: 20px;
    bottom: 84px;
    width: 52px;
    height: 52px;
    font-size: 22px;
    box-shadow: 0 4px 12px rgba(0,0,0,.25);
    z-index: 999;
  }

  // ── 對話框內的 form ─────────────────────────────
  .m-dialog-form {
    .m-form-item {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 14px;

      label {
        width: 72px;
        flex-shrink: 0;
        font-size: 13px;
        color: #606266;
        white-space: nowrap;
        text-align: right;
      }

      .el-input,
      .el-select,
      .el-date-picker {
        flex: 1;
      }

      span {
        flex: 1;
        font-size: 14px;
        color: #303133;
      }
    }
  }
}

// ── 收合動畫 ──────────────────────────────────────
.slide-enter-active,
.slide-leave-active {
  transition: all .25s ease;
  overflow: hidden;
  max-height: 600px;
}
.slide-enter,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}
</style>
